import CT from '@marketplace-ai/tags';
import { WizardFooter as SharedWizardFooter } from '~/components/Wizard/WizardFooter';
const TAGS = CT.peerRef.form;

export interface FooterProps {
  nextBtn: {
    onClick: () => void;
    text: string;
  };
  prevBtn?: {
    onClick: () => void;
  };
}

/**
 * [MCV-1577] Thin adapter over the shared wizard action bar.
 *
 * This used to hand-roll its own row (`mt-6 ... border-grey-900 pt-6`) with
 * buttons that kept their 126px min-width on a phone, so the peer-reference
 * wizard's Previous/Next bar sat on a different rule and stacked differently
 * from every other wizard in the app. Delegating keeps the local
 * `{ nextBtn, prevBtn }` prop shape — and this feature's cy tags — so all four
 * peer-reference steps inherit the shared bar without a caller change. Same
 * pattern as features/vault/academics/training/trainingWizard/WizardFooter.tsx.
 *
 * `sticky={false}` is the one deliberate difference from that vault adapter.
 * The vault wizards render inside a FormDialog, which owns a bounded scroll
 * container, so the shared bar's default pins correctly there. `/peerReference/
 * :magicLink` instead renders its card in normal page flow under a `min-h-screen`
 * wrapper (see PeerReference.tsx) with no scroll container of its own, so
 * `sticky bottom-0` would resolve against the viewport and park the actions over
 * the middle of a long step. Regression covered by
 * features/peerReference/__tests__/PeerReferenceActions.browser.spec.tsx.
 */
export const WizardFooter = (props: FooterProps) => {
  const { nextBtn, prevBtn } = props;

  return (
    <SharedWizardFooter
      sticky={false}
      backButton={
        prevBtn ? { label: 'Previous', cyTag: TAGS.prevBtn, onClick: prevBtn.onClick } : undefined
      }
      primaryButton={{ label: nextBtn.text, cyTag: TAGS.nextBtn, onClick: nextBtn.onClick }}
    />
  );
};
